/* Scale the fixed 1440px Figma canvas to the window width so the frame is
   reproduced exactly at any screen size. Nothing reflows — it only scales. */
(function () {
  "use strict";

  var FRAME_W = 1440;
  var FRAME_H = 2976;
  var canvas = document.getElementById("canvas");
  var viewport = document.querySelector(".viewport");

  /* The 1440 frame is a design reference, not a pixel canvas. Presenting it
     1:1 on a 1512-1728px laptop magnified everything (84px headings rendered
     at ~100px). Laying it out against a wider notional width scales the whole
     composition down coherently — every absolute Figma coordinate keeps its
     relationship, the design just occupies a normal share of the screen. */
  var PRESENT_W = 1760;
  var MAX_SCALE = FRAME_W / PRESENT_W;   /* ~0.82 */

  /* The capture band and footer now live outside the canvas as normal flow
     content, so the canvas only has to reserve the artwork above them —
     everything up to .capture's old top edge. */
  var TAIL_TOP = 1940;

  /* Where the first tour row sits, and how far apart they step, in canvas
     units. Kept in sync with the same numbers in snippets/tour-dates.liquid. */
  /* Lifted 178px with .h-live and .lede-live, which moved up when the shop
     block above them was tightened. */
  var ROW_TOP = 1266;
  /* The empty teaser is 260px shorter than the product grid, and the CSS
     lifts .h-live with it; the rows and the canvas tail follow here. */
  var EMPTY_LIFT = 268;
  var ROW_STEP = 120;
  var ROWS_BASELINE = 4;   /* the count TAIL_TOP was measured against */

  /* Tops in canvas coordinates — where each block's heading sits. */
  var SHOP_TOP = 116;    /* .h-shop */
  var LIVE_TOP = 1038;   /* .h-live */
  var GAP = 64;          /* device-px breathing room between blocks */
  var shop = document.querySelector(".shop-block");
  var live = document.querySelector(".live-block");

  /* Shop launches later than the site. When its block is absent the canvas
     would keep a ~1000px hole where it used to sit, so the live section and
     everything below it move up by exactly that gap. Desktop only — the
     mobile branch below already re-stacks from a cursor. */
  var SHOP_SPAN = LIVE_TOP - SHOP_TOP;   /* 834 canvas units */
  var shopHidden = !shop;

  function fit() {
    var scale = Math.min(window.innerWidth / FRAME_W, MAX_SCALE);
    var offset = Math.max((window.innerWidth - FRAME_W * scale) / 2, 0);
    canvas.style.transform = "translateX(" + offset + "px) scale(" + scale + ")";
    /* Full-width dark bands must cover the cream gutters left by the centred
       canvas. The gutter grows with the window, so the bleed is measured
       rather than a fixed guess (a 600px constant broke past ~1900px). */
    var bleed = Math.ceil(offset / scale) + 40;
    canvas.style.setProperty("--bleed", bleed + "px");

    /* Below 760px the shop and live blocks opt out of the canvas scale (see
       .shop-block / .live-block in home.css) so their contents render at a
       readable size. Each is still a canvas child, so it needs the inverse
       scale to cancel the parent transform. Because both grow far taller
       than their scaled slots, they are re-stacked in sequence and the
       viewport reserves their REAL height — otherwise they would overlap
       each other and the capture band below. */
    var mobile = window.matchMedia("(max-width: 760px)").matches;
    var tailTop = TAIL_TOP;
    var more = document.querySelector("[data-live-more]");

    if (mobile && (shop || live)) {
      var inv = 1 / scale;
      var gap = GAP / scale;   /* device px -> canvas units */
      var cursor = SHOP_TOP;

      /* The canvas scales this subtree by `scale`, and the block's own
         transform scales it back by 1/scale — so laid-out width and screen
         width are equal, and each block simply takes the viewport width. */
      if (shop) {
        shop.style.setProperty("--unscale", inv);
        shop.style.width = window.innerWidth + "px";
        shop.style.top = cursor + "px";
        /* getBoundingClientRect is post-transform (device px); convert back
           to canvas units so it can be added to a canvas-space offset. */
        cursor += shop.getBoundingClientRect().height / scale + gap;
      }

      if (live) {
        live.style.setProperty("--unscale", inv);
        live.style.width = window.innerWidth + "px";
        live.style.top = cursor + "px";
        cursor += live.getBoundingClientRect().height / scale + gap;
      }

      /* The desktop branch pins the CTA at a canvas coordinate; on mobile it
         rejoins normal flow, so those inline styles have to go or a resize
         from desktop leaves it stranded. */
      if (more) {
        more.style.removeProperty("top");
        more.style.removeProperty("left");
        more.style.removeProperty("width");
        more.hidden = false;
      }

      tailTop = cursor;
    } else {
      /* The canvas reserved room for four rows whatever rendered, so a
         two-show homepage left a screen of dead space above the social band.
         Measure what is actually there and pull the tail up by the difference.
         The CTA is placed under the last row here for the same reason. */
      var rows = live ? live.querySelectorAll(".tour-row").length : 0;
      var empty = live ? live.querySelector(".tour-empty") : null;
      var teaserEmpty = !!document.querySelector(".tprod--empty");
      var rowTop = ROW_TOP - (teaserEmpty ? EMPTY_LIFT : 0);

      /* Nothing to see all of, so the link would send people to an equally
         empty page. The empty-state block stands on its own. */
      if (more) more.hidden = rows === 0;

      if (empty) {
        /* The block sits where the first row would, so the tail closes up
           against it as if a single row had rendered. */
        var emptyH = empty.getBoundingClientRect().height / scale;
        tailTop = rowTop + emptyH + 80;
      }

      if (rows > 0) {
        var lastBottom = rowTop + (rows - 1) * ROW_STEP + ROW_STEP;
        if (more) {
          more.style.top = lastBottom + 22 + "px";
          /* Centred across the row span rather than pinned to its left edge:
             the rows start at 80px and run 1280px wide, so the link is laid
             out across that same span and centres itself within it. */
          more.style.left = "80px";
          more.style.width = "1280px";
        }
        var shortfall = (ROWS_BASELINE - rows) * ROW_STEP;
        if (shortfall > 0) tailTop -= shortfall;
      } else if (more) {
        more.style.removeProperty("top");
        more.style.removeProperty("left");
        more.style.removeProperty("width");
      }

      if (teaserEmpty) tailTop -= EMPTY_LIFT;

      if (shopHidden) {
        /* .live-block is an unpositioned wrapper on desktop; its children hold
           the canvas coordinates, so the shift is applied in home.css via
           .canvas--no-shop rather than by moving the wrapper. */
        tailTop = TAIL_TOP - SHOP_SPAN;
      }

      [shop, live].forEach(function (el) {
        if (!el) return;
        el.style.removeProperty("--unscale");
        el.style.removeProperty("width");
        el.style.removeProperty("top");
      });
    }

    viewport.style.height = tailTop * scale + "px";
  }

  fit();
  window.addEventListener("resize", fit);

  /* Header surface + hide-on-scroll-down — matches the .header behavior on
     every other page, so the chrome reads identically sitewide. See the
     commentary in assets/goopie.js; this is the same logic for the
     homepage's own bar, which is a different element. */
  var topbar = document.querySelector(".topbar");
  if (topbar) {
    var HIDE_AFTER = 8;
    var SHOW_AFTER = 4;
    var last = window.scrollY;
    var ticking = false;

    var update = function () {
      ticking = false;
      var y = window.scrollY;
      var delta = y - last;

      topbar.classList.toggle("is-stuck", y > 24);

      if (y <= topbar.offsetHeight || topbar.contains(document.activeElement)) {
        topbar.classList.remove("is-hidden");
      } else if (delta > HIDE_AFTER) {
        topbar.classList.add("is-hidden");
      } else if (delta < -SHOW_AFTER) {
        topbar.classList.remove("is-hidden");
      }

      if (Math.abs(delta) > SHOW_AFTER) last = y;
    };

    update();
    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    topbar.addEventListener("focusin", function () {
      topbar.classList.remove("is-hidden");
    });
  }
})();
